/* @ngInject */
const myWagonOwnerSearch = (
  $$owner,
  wagonFields,
  toaster,
  valueHandler
) => {
  return {
    restrict: 'E',
    scope: {
      myWagon: '=',
    },
    template: require('./myWagonOwnerSearch.html'),
    /* @ngInject */
    controller: ($scope) => {
      $scope.fieldsOptions = wagonFields
    },
    link: {
      pre: (scope, element, attrs) => {

        scope.myWagon = scope.myWagon || {}
      },
      post: async (scope, element, attrs, ctrl) => {
        try {
          const response = await $$owner.request.getAll()
          scope.owners = response.owners
        } catch (error) {
          toaster.error(error)
        }

        scope.$watch('myWagon.ownerId', (newValue, oldValue) => {
          if (newValue !== oldValue) {
            if (valueHandler.isEmpty(newValue)) {
              scope.myWagon.ownerId = undefined
            }
          }
        })
      },
    },
  }
}
export default myWagonOwnerSearch



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/trains/wagon/directives/search/myWagonOwnerSearch.js